import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {
    Cell,
    HCell,
    HRow,
    InputFilter,
    Pagination,
    Panel,
    PanelRow,
    Row,
    SelectFilter,
    CustomTable, PaginationV2
} from "./table-utils";
import Config from "../../../services/config";

import { 
    PerPageFilter as AwrabetPerPageFilter,
    OutcomeCodeFilter as AwrabetOutcomeCodeFilter,
    FromAcceptanceFilter as AwrabetFromAcceptanceFilter,
    SearchTypeFilter as AwrabetSearchTypeFilter,
    EventsLeftCountFilter as AwrabetEventsLeftCountFilter,
    TicketEventsCountFilter as AwrabetTicketEventsCountFilter,
    TicketTypeFilter as AwrabetTicketTypeFilter,
    TicketStatusFilter as AwrabetTicketStatusFilter,
    TicketEndDateFilter as AwrabetTicketEndDateFilter,
    DateHelperFilter as AwrabetDateHelperFilter,
    TableFormatter as AwrabetTableFormatter,
 } from "../../awrabet/utils/form-utils";

export class PerPageFilter extends AwrabetPerPageFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Record Per Pagina</Trans></span>
            <SelectFilter class="inline-block bg-white py-2 leading-3 w-full" onChange={e => {this.state.perPage = e.currentTarget.value; this.onInput();}}>
                {this.state.pageList.map(n => <option value={n} selected={n === parseInt(this.state.perPage)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class OutcomeCodeFilter extends AwrabetOutcomeCodeFilter {
    render() {
        return <label class="mx-px px-2">
            <span class="block text-xs whitespace-pre"><Trans>Codice Esito</Trans></span>
            <InputFilter
                type="text"
                class="w-40 px-2 py-1 leading-6 rounded border"
                value={this.state.searchOutcome}
                onInput={e => {
                    this.state.searchOutcome = e.target.value;
                    this.onInput();
                }}
            />
            <a href="javascript:void(0);" class="ml-2" onClick={e => this.openHelpPopup()}><i class="fa-solid fa-circle-info text-blue-600" /></a>
        </label>;
    }
}

export class FromAcceptanceFilter extends AwrabetFromAcceptanceFilter {
    render() {
        return <label class="mx-px px-2">
            <span class="block text-xs whitespace-pre"><Trans>Da Riserva</Trans></span>
            <InputFilter
                type="checkbox"
                class="block mt-2 mb-3 m-auto"
                checked={this.state.searchStock}
                onInput={e => {
                    this.state.searchStock = !this.state.searchStock;
                    this.onInput();
                }}
            />
        </label>;
    }
}

export class SearchTypeFilter extends AwrabetSearchTypeFilter {
    render() {
        return [
            <label class="mx-px">
                <span class="block text-xs"><Trans>Tipo Di Ricerca</Trans></span>
                <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchType = e.currentTarget.value; this.onInput();}}>
                    {Object.entries(this.filterTypeList()).map(
                        ([key,optiontext]) => <option value={key} selected={key === this.state.searchType}>{optiontext}</option>
                    )}
                </SelectFilter>
            </label>,
            <label class="mx-px">
                <span class="block text-xs"><Trans>Stringa Di Ricerca</Trans></span>
                <input type="input" class="w-40 px-2 py-1 leading-6 rounded border" value={this.state.searchString} onInput={e => {this.state.searchString = e.target.value; this.onInput();}} />
            </label>,
            <label class="mx-px px-2">
                <span class="block text-xs whitespace-pre"><Trans>Confronto Esatto</Trans></span>
                <InputFilter type="checkbox" class="block mt-2 mb-3 m-auto" checked={this.state.searchExact} onInput={e => {this.state.searchExact = !this.state.searchExact; this.onInput();}} />
            </label>
        ];
    }
}

export class EventsLeftCountFilter extends AwrabetEventsLeftCountFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Eventi Mancanti</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchForPrese = e.currentTarget.value; this.onInput();}}>
                <option value="" selected={0 === parseInt(this.state.searchForPrese)}><Trans>Tutti</Trans></option>
                {Array.from({length: 20}, (_, i) => i + 1).map(n => <option value={n} selected={n === parseInt(this.state.searchForPrese)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class TicketEventsCountFilter extends AwrabetTicketEventsCountFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Numero Eventi</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchBetEvents = e.currentTarget.value; this.onInput();}}>
                <option value="0" selected={0 === parseInt(this.state.searchBetEvents)}><Trans>Tutti</Trans></option>
                {Array.from({length: 20}, (_, i) => i + 1).map(n => <option value={n} selected={n === parseInt(this.state.searchBetEvents)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class TicketTypeFilter extends AwrabetTicketTypeFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Tipo Scommessa</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchBetType = e.currentTarget.value; this.onInput();}}>
                {Object.entries(this.betTypeList()).map(
                    ([key,optiontext]) => <option value={key} selected={key === this.state.searchBetType}>{optiontext}</option>
                )}
            </SelectFilter>
        </label>;
    }
}

export class TicketStatusFilter extends AwrabetTicketStatusFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Stato Scommessa</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchStatus = e.currentTarget.value; this.onInput();}}>
                {Object.entries(this.betStatusList()).map(
                    ([key,optiontext]) => <option value={key} selected={key === this.state.searchStatus}>{optiontext}</option>
                )}
            </SelectFilter>
        </label>;
    }
}

export class TicketEndDateFilter extends AwrabetTicketEndDateFilter {
    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Ticket Conclusi...</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.useTicketEnd = e.currentTarget.value; this.onInput();}}>
                <option value="" selected={this.state.useTicketEnd === ''}><Trans>in qualsiasi momento</Trans></option>
                <option value="on" selected={this.state.useTicketEnd === 'on'}><Trans>entro la data fine</Trans></option>
            </SelectFilter>
        </label>;
    }
}

export class DateHelperFilter extends AwrabetDateHelperFilter {
    render({firstChild, helperValue}) {
        return [
            <label class={"mx-px "+(firstChild || '')}>
                <span class="block text-sm"><Trans>Aiuto Data</Trans></span>
                <SelectFilter class={"text-black bg-white leading-3 w-full "+(this.props.class || ' py-2')} onChange={e => this.dateHelper(e.currentTarget.value)}>
                    <option value="0" selected={this.state.helperValue === 0}><Trans>Personalizzato</Trans></option>
                    <option value="1" selected={this.state.helperValue === 1}><Trans>Oggi</Trans></option>
                    <option value="2" selected={this.state.helperValue === 2}><Trans>Ultimi 2 Giorni</Trans></option>
                    <option value="3" selected={this.state.helperValue === 3}><Trans>Ultimi 7 Giorni</Trans></option>
                    <option value="4" selected={this.state.helperValue === 4}><Trans>Ultimi 30 Giorni</Trans></option>
                </SelectFilter>
            </label>,
            <label class="mx-px">
                <span class="block text-sm"><Trans>Data Inizio</Trans></span>
                <InputFilter
                    class={"text-black py-2 leading-3 w-full "+(this.props.class || '')}
                    type="date"
                    value={this.state.dateStartValue}
                    onInput={e => {
                        this.state.dateStartValue = e.target.value;
                        this.state.helperValue = 0;
                        this.onInput();
                    }}
                />
            </label>,
            <label class="mx-px">
                <span class="block text-sm"><Trans>Data Fine</Trans></span>
                <InputFilter
                    class={"text-black py-2 leading-3 w-full "+(this.props.class || '')}
                    type="date"
                    value={this.state.dateEndValue}
                    onInput={e => {
                        this.state.dateEndValue = e.target.value;
                        this.state.helperValue = 0;
                        this.onInput();
                    }}
                />
            </label>
        ];
    }
}

export class TableFormatter extends AwrabetTableFormatter {
    render() {
        const TotalNumberOfPages = Math.ceil(this.state.totalrecords/this.state.recordperpage);
        const rowsDataMapper = this.state.rowsDataMapper;
        const rowDataMapper = this.state.rowDataMapper === null && this.state.rowsDataMapper === null?
            item => item : (this.state.rowDataMapper === null? null : this.state.rowDataMapper);

        return <Panel class="overflow-x-auto">
            <PanelRow>
                {!this.state.data.length?
                    <div class="text-center text-lg text-gray-500">
                        <Trans>Non ci sono record da mostrare</Trans>
                    </div>
                    : <CustomTable style={this.state.style} class={this.state.class}>
                        {this.state.colGroupMapper !== false && <colgroup>{this.state.colGroupMapper}</colgroup>}
                        {this.tableHead()}
                        <tbody class="text-center">
                        {!!rowDataMapper && this.state.data.map((row,j) => rowDataMapper(row,j)).map(
                            cells => <Row class={this.state.rowClass}>
                                {cells.map((item,i) => <Cell first={!this.state.noFirstCell && i===0} class={!!this.state.cellClass? this.state.cellClass : "p-1"} borderColor="var(--main-color)">
                                    {!Array.isArray(item)? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                        {!!rowsDataMapper && this.state.data.flatMap((row,j) => rowsDataMapper(row,j)).map(
                            cells => <Row class={this.state.rowClass}>
                                {cells.map((item,i) => <Cell first={!this.state.noFirstCell && i===0} colspan={cells.length===1? this.state.columns.length : 1} class={!!this.state.cellClass? this.state.cellClass : (cells.length===1? 'p-0' : 'p-1')} borderColor="var(--main-color)">
                                    {!Array.isArray(item)? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                        </tbody>
                    </CustomTable>}
            </PanelRow>
            {this.state.onNavigation !== false && !!this.state.data.length && <PaginationV2
                pages={TotalNumberOfPages}
                currentPage={this.state.page}
                onNavigation={(page) => {this.state.onNavigation(page, page*this.state.recordperpage-this.state.recordperpage)}}
                isLastPage={TotalNumberOfPages===this.state.page}
            />}
        </Panel>;
    }
}
